module.exports = __webpack_public_path__ + "img/footerLogo.44693af9.png";